import styled from 'styled-components'
import { Link } from 'react-router-dom'
import colors from '../utils/style/colors'

const Wrap = styled.footer`
  background: ${colors.texte};
  padding: 56px 48px 28px;
  border-top: 1px solid rgba(200,168,75,0.15);
  @media (max-width: 768px) { padding: 40px 20px 24px; }
`
const Top = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 44px;
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 28px; }
`
const BrandName = styled.div`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: ${colors.orClair};
  margin-bottom: 12px;
  letter-spacing: 0.02em;
`
const BrandDesc = styled.p`
  font-size: 0.84rem;
  color: rgba(255,255,255,0.45);
  line-height: 1.68;
  font-family: ${colors.font};
  max-width: 250px;
`
const ColTitle = styled.div`
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${colors.or};
  font-family: ${colors.font};
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(200,168,75,0.2);
`
const FootLink = styled(Link)`
  display: block;
  color: rgba(255,255,255,0.45);
  text-decoration: none;
  font-size: 0.85rem;
  font-family: ${colors.font};
  margin-bottom: 10px;
  transition: color 0.2s;
  &:hover { color: ${colors.orClair}; }
`
const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,0.45);
  font-size: 0.85rem;
  font-family: ${colors.font};
  margin-bottom: 10px;
  i { color: ${colors.or}; width: 16px; }
`
const Divider = styled.div`
  border-top: 1px solid rgba(255,255,255,0.08);
  padding-top: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`
const Copy = styled.p`
  color: rgba(255,255,255,0.22);
  font-size: 0.78rem;
  font-family: ${colors.font};
`
const Legal = styled(Link)`
  color: rgba(255,255,255,0.22);
  font-size: 0.78rem;
  font-family: ${colors.font};
  text-decoration: none;
  transition: color 0.2s;
  &:hover { color: rgba(255,255,255,0.5); }
`

export default function Footer() {
  return (
    <Wrap>
      <Top>
        <div>
          <BrandName>AchatPaille.com</BrandName>
          <BrandDesc>
            Export direct de paille et fourrage depuis la France vers la Suisse.
            Qualité garantie, livraison clé en main, formalités douanières incluses.
          </BrandDesc>
        </div>
        <div>
          <ColTitle>Navigation</ColTitle>
          <FootLink to="/">Accueil</FootLink>
          <FootLink to="/produits">Nos produits</FootLink>
          <FootLink to="/pourquoi-nous">Pourquoi nous</FootLink>
          <FootLink to="/contact">Contact</FootLink>
          <FootLink to="/devis">Demander un devis</FootLink>
          <FootLink to="/suivi-devis">Suivre mon devis</FootLink>
        </div>
        <div>
          <ColTitle>Informations</ColTitle>
          <ContactItem><i className="fa-solid fa-truck" />Livraison France → Suisse</ContactItem>
          <ContactItem><i className="fa-solid fa-clock" />Réponse sous 24h</ContactItem>
          <ContactItem><i className="fa-solid fa-shield-halved" />Douane incluse</ContactItem>
          <ContactItem><i className="fa-solid fa-star" />100% origine France</ContactItem>
        </div>
      </Top>
      <Divider>
        <Copy>© {new Date().getFullYear()} AchatPaille.com — Paille & Fourrage France → Suisse. Tous droits réservés.</Copy>
        <Legal to="/mentions-legales">Mentions légales</Legal>
      </Divider>
    </Wrap>
  )
}
